const initialData = {
  "location": {
    "name": "-",
    "region": "-",
    "country": "-",
    "localtime": "-"
  },
  "current": {
    "temp_c": 0,
    "temp_f": 0,
    "condition": {
      "text": "-",
      "icon": "//cdn.weatherapi.com/weather/64x64/day/122.png"
    }
  }
}

export default initialData